var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { Avatar, Card } from '@philips-internal/oswald-ui-components/lib/components';
import { ModelService, MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { eventListener, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { ReactComponent as TimeIconSVG } from '../../assets/images/global/hpms-time.svg';
import { ReactComponent as CheckBlueIconSVG } from '../../assets/images/global/check-blue.svg';
import { ReactComponent as CheckIconSVG } from '../../assets/images/global/check-green.svg';
import radiologyLabIconSVG from '../../assets/images/avatars/radiology_lab.svg';
import laboratoryIconSVG from '../../assets/images/avatars/avatar_lab.svg';
import undefinedIconSVG from '../../assets/images/global/hpms-user.svg';
import './card-exams-list-item.css';
let CardExamsListItem = class CardExamsListItem extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            data: {},
            visible: true,
            width: 12
        };
        this.onClick = () => {
            const { onClick } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        onClick
                    }
                }));
            }
        };
    }
    getSvg() {
        const { status } = this.props;
        if (status == 'A') {
            return React.createElement(CheckIconSVG, { className: 'status-icon' });
        }
        if (status == 'P') {
            return React.createElement(TimeIconSVG, { className: 'status-icon' });
        }
        if (status == 'R') {
            return React.createElement(CheckBlueIconSVG, { className: 'status-icon' });
        }
        return React.createElement(React.Fragment, null);
    }
    getSvgStand() {
        const { type } = this.props;
        if (type == 'L' || type == 'P') {
            return (React.createElement("div", { className: 'card-avatar' },
                React.createElement(Avatar, { image: laboratoryIconSVG })));
        }
        if (type == 'N') {
            return (React.createElement("div", { className: 'card-avatar' },
                React.createElement(Avatar, { image: radiologyLabIconSVG })));
        }
        return (React.createElement("div", { className: 'card-avatar' },
            React.createElement(Avatar, { image: undefinedIconSVG })));
    }
    getExpression() {
        const { status } = this.props;
        if (status == 'A') {
            return 'result.available';
        }
        if (status == 'P') {
            return 'result.processing';
        }
        if (status == 'R') {
            return 'result.ready';
        }
        return '';
    }
    render() {
        const { nmExame, status, nmPessoaFisica, dtProcedimento } = this.props;
        return (React.createElement(Card, { onClick: () => this.onClick(), width: 12, className: 'card-exams-list-item', selectionType: SelectionType.SINGLE, uuid: "cc12ce28-962b-4bd0-9d7c-22ddf6707e3c" },
            React.createElement("div", { className: `card-status-bar ${status}` }),
            this.getSvgStand(),
            React.createElement("div", { className: 'card-content' },
                React.createElement("div", { className: 'card-left-content' },
                    React.createElement("div", { className: 'card-left-info-content' },
                        React.createElement("div", { className: 'content-exame-name' }, nmExame),
                        React.createElement("div", { className: 'content-physician-name' }, `${MessageService.translate('result.requested-by')} ${nmPessoaFisica}`)),
                    React.createElement("div", { className: 'content-date' }, ModelService.format('date', dtProcedimento))),
                React.createElement("div", { className: 'card-right-content' },
                    React.createElement("div", { className: 'content-status' },
                        this.getSvg(),
                        React.createElement("div", { className: 'content-text-status' }, MessageService.translate(this.getExpression())))))));
    }
};
CardExamsListItem.propTypes = {
    onClick: eventListener,
    nmExame: string,
    nmPessoaFisica: string,
    dtProcedimento: string,
    status: string,
    type: string
};
CardExamsListItem = __decorate([
    AwesomeComponent({ type: ComponentType.DATA_DISPLAY })
], CardExamsListItem);
export default CardExamsListItem;
//# sourceMappingURL=card-exams-list-item.js.map